// export default Sidebar;
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../Assets/images/logo.png';
import sidebararrow from '../Assets/images/closebtn.svg';
import { logout } from '../Services/Authentication.Serivice';
import Toaster from './Toaster';
import TokenService from '../Services/Token.service';
import { GlobalInfo } from '../Contexts/GlobalContext';
import { Accordion } from 'react-bootstrap';

function Sidebar({ isLoggedIn, setIsLoggedIn, isSidebarVisible, toggleSidebar }) {
  const {userDetails} = useContext(GlobalInfo);
  const navigate = useNavigate();
  const location = useLocation();
  const [menus, setMenus] = useState([]);
  const [userName, setUserName] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState(''); // 'success' or 'error'
  const dirPath = process.env.REACT_APP_SUB_DIR;

  useEffect(() => {   
    if(typeof userDetails === 'undefined' || userDetails === null) return;      
    setMenus(userDetails.menus || []);

  }, [userDetails]);

  //uncomment this for one accoridon open at once
  // useEffect(() => {
  //   if (menus.length > 0) {
  //     const key = getActiveParentKey();
  //     setActiveAccordionKey(key);
  //   }
  // }, [menus, location.pathname]);

  useEffect(() => {
  if (menus.length > 0) {
    setTimeout(() => {
      const firstAccordion = document.querySelector(
        '.el-sidebar .accordion-item .accordion-collapse'
      );
      if (firstAccordion && !firstAccordion.classList.contains('show')) {
        firstAccordion.classList.add('show'); // ✅ Open the first only
      }
    }, 0);
  }
}, [menus]);



  useEffect(() => {      
    const storedUser = TokenService.getUser();
    if (storedUser) {
      setUserName(storedUser.user.display_name);
      setMenus(storedUser.menus || []);
    }
  }, [isLoggedIn]);

  const handleLogout = async (values) => {
    try {
      const response = await logout();
      if (response.status) {
        
        TokenService.removeUser(); 
        setIsLoggedIn(false);
        navigate("/login");

      } else {
        // Set error toast
        setToastMessage(response.message);
        setToastVariant('error');
        setShowToast(true);
      }
    } catch (error) {
      // Set error toast
      setToastMessage(error.response?.data?.error || 'An error occurred. Please try again later.');
      setToastVariant('error');
      setShowToast(true);
    }
  };

const handleNavigate = (children, slug, role, isFirstLevelChild = false) => {
  
  //  Update prevLink only for top-level (Accordion.Header) 
  // OR its immediate children (li inside Accordion.Body)
  
//  if (slug !== '#' && isFirstLevelChild) {
    TokenService.updatePrevLink(`/${role}/${slug}`);
  // }


  // Always update menu
  TokenService.updateAdministratorMenu(children);

  if (slug !== '#') {
    navigate(`/${role}/${slug}`, {
      state: { children }, // Pass children as part of state
    });
  }
};


  const isActive = (slug, role) => {
    // Check if the current pathname includes both the role and the slug 
    return location.pathname.includes(`/${role}/${slug}`) ? 'active' : '';
  };
  

  const renderMenuItemsBCKP = (menuItems, role) => {
    const userRestrictions = TokenService.getUserRestrictions() || [];

    const filteredMenuItems = menuItems.filter((item) => {      
      if(typeof userRestrictions !== 'undefined' && userRestrictions.length > 0 && userRestrictions.includes(item.slug)) {
        return false
      }
      return true;
    });    

    return filteredMenuItems.map((item) => {
    // If item has children → use Accordion
    if (item.children && item.children.length > 0) {
      return (
        <Accordion key={item.id} className="el-submenu" alwaysOpen>
          <Accordion.Item className='el-submenu-item' eventKey={item.id.toString()}>
            <Accordion.Header  onClick={() => handleNavigate(item.children, item.slug, role, true) }>
              <i className={item.icon || "el-icon-default"}></i>
              <span>{item.name}</span>
            </Accordion.Header>
            <Accordion.Body>
              <ul className="nav flex-column">
                 {/* ms-3 */}
                {item.children.map((m) => (
                  <li
                    key={m.id}
                    className="nav-item"
                    onClick={() =>  handleNavigate(
                      item.children,
                      `${item.slug}/${m.slug}`,
                      role,
                      false
                    )}
                  >
                    <a className={`nav-link ${isActive( `${item.slug}/${m.slug}`, role)}`}>
                    <div className="d-flex align-items-center">
                      <i className={m.icon || "el-icon-default"}></i>
                      <div>
                      <span>{m.name}</span>
                      </div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      );
    }

  return (
      <li
        key={item.id}
        className="nav-item"
        onClick={() =>{ handleNavigate(menuItems, item.slug, role, false)}}
      >
        <a className={`nav-link ${isActive(item.slug, role)}`}>
          <div className="d-flex align-items-center">
          <i className={item.icon || "el-icon-default"}></i>
          <div>
          <span>{item.name}</span>
          </div>
          </div>
        </a>
      </li>
    );
    });
  };

  
  
  const controllerType = (slug) => {

    switch (slug) {
      case 'admin-controls':     
      case '#':
      case 'administrative-settings':
        return 'admin';
//  case 'administrative-settings':
        // return 'admin/administrative-setting';

      case 'requestor-controls':
        return 'requestor';
    
      case 'donor-controls':
        return 'donor';
    
      case 'profile-management':
        return 'profile-management';
    
      default:
        return ''; // Or any default value if needed
    }

  }
  
  function getNavigationPath(slug) {
    const routes = {
        "admin-controls": "sample-requests",
        "donor-controls": "job-board",
        "requestor-controls": "requestor-sample-requests",
        "profile-management": "profile-management",
    }; 
    // Return the mapped route or the original slug if no match is found
    return routes[slug] || slug;
}
  const handleLogoClick = (e) => {
    // Get the previous link or default dashboard based on role
   
        e.preventDefault();
        const user = TokenService.getUser();
        const role = user.roles.find((r) => r.toLowerCase() === "superadmin"); // Assuming roles is an array
        if (role) {
            navigate('/admin/sample-requests');
        } else { 
          // Navigate to the respective role's page
          const currentRole = user.roles[0]?.toLowerCase(); // Default to the first role if no "Superadmin" is found
          const slug = user.menus[0].slug;
          const navigationPath = getNavigationPath(slug);

          if (navigationPath === "profile-management") {
              navigate(`/profile-management/profile-settings`);
              
          } else {
              navigate(`/${currentRole}/${user.menus[0].children[0].slug}`);
              TokenService.updatePrevLink(`/${currentRole}/${user.menus[0].children[0].slug}`);

          }
      }
};
  const renderMenu = () => {
    if (!isLoggedIn || !menus.length) return null;

    return (
      <div  className={`el-sidebar ${isSidebarVisible ? 'visible' : ''}`} style={{ width: '280px', marginLeft: isSidebarVisible ? '0' : '-100%' ,zIndex:1}}>
        <div className="el-logo">
          <a href="" onClick={handleLogoClick}><img src={Logo} alt="" /></a>
          <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
            <span className="navbar-toggler-icon">
              <img src={sidebararrow} alt="" />
            </span>
          </button>
          
        </div>
       
        <nav className="navbar navbar-expand-lg">
          <div className="collapse navbar-collapse">
            <ul className="nav nav-pills flex-column mb-auto">
              {/* <Accordion  
              //uncomment this for one accoridon open at once
                activeKey={activeAccordionKey}
                onSelect={(key) =>
                  setActiveAccordionKey(activeAccordionKey === key ? null : key)
                }
                flush
              > */}
              <Accordion alwaysOpen flush>
                {menus.map((menu, index) =>{ 
                // {/* //took 'HELP' menu at bottom of all menues */}
                  if(menu.name === 'Help'){
                    return;
                  }
                  return (
                  <Accordion.Item eventKey={index.toString()} key={menu.id}>
                    <Accordion.Header onClick={() => {
                      if(menu.slug ==='administrative-settings'){
                      handleNavigate(menu.children, menu.slug,  controllerType(menu.slug), true) }}
                      }>

                      <span className="el-navlabel">
                        <i className={menu.icon || "el-icon-default"}></i>
                        {menu.name}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body>
                      {menu.children &&
                        renderMenuItemsBCKP(menu.children, controllerType(menu.slug))}
                    </Accordion.Body>
                  </Accordion.Item>
                )})}
              </Accordion>
              
              {/* //took HELP at bottom of all menues */}
              {menus.map((menu, index) =>{
                if(menu.name === 'Help'){ 
                  return (
                  <Accordion alwaysOpen flush>
                  {/* <Accordion.Item eventKey={index.toString()} key={menu.id}>
                    <Accordion.Header> */}
                        {/* {menu.name} */}
                    <li className="nav-item">
                       <a  className="nav-link" onClick={(e) =>{e.preventDefault(); navigate(`/${menu.slug}`);}} href={`/${menu.slug}`}><i className= {`${menu.icon || "el-icon-default"}`}></i> <span>{menu.name}</span></a>
                    </li>
                    {/* </Accordion.Header>
                      <Accordion.Body>
                      </Accordion.Body>
                  </Accordion.Item> */}
                  </Accordion>
                );
              }
              })}
              {/* {menus.map((menu, index) =>{ 
                if(menu.name === 'Help'){
                  return (
                    <li className="nav-item">
                       <a  className="nav-link" href={menu.slug}><i className= {`nav-link ${menu.icon || "el-icon-default"}`}></i> <span>{menu.name}</span></a>
                    </li>
                  )
                }
              })} */}

              {/* Logout link */}
              <li className="nav-item mt-3" onClick={handleLogout}>
                <a className="nav-link">
                  <i className="el-icon-logout"></i>
                  <span>Logout</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>

      </div>

    );
  };
  // const getActiveParentKey = () => {debugger
  //   if (!menus || !menus.length) return null;
  //   for (let i = 0; i < menus.length; i++) {
  //     const menu = menus[i];
  //     if (menu.children && menu.children.length > 0) {
  //       // Check if any child slug matches current pathname
  //       for (let child of menu.children) {
  //         const role = controllerType(menu.slug);
  //       const fullPath1 = `/${role}/${menu.slug}/${child.slug}`; // parent/child
  //       const fullPath2 = `/${role}/${child.slug}`;             // just child
  //         if (location.pathname.startsWith(fullPath1) || location.pathname.startsWith(fullPath2)) {
  //           return i.toString(); // Accordion key is string
  //         }
  //       }
  //     }
  //   }
  //   return null;
  // };
const getActiveParentKey = () => {
  if (!menus || !menus.length) return null;

  for (let i = 0; i < menus.length; i++) {
    const menu = menus[i];
    const role = controllerType(menu.slug);

    // Check parent route itself
    const parentPath = `/${role}/${menu.slug}`;
    if (location.pathname.startsWith(parentPath)) {
      return i.toString(); // Accordion key is string
    }

    // Check children routes
    if (menu.children && menu.children.length > 0) {
      for (let child of menu.children) {
        const fullPath1 = `/${role}/${menu.slug}/${child.slug}`; // parent/child
        const fullPath2 = `/${role}/${child.slug}`;              // just child

        if (
          location.pathname.startsWith(fullPath1) ||
          location.pathname.startsWith(fullPath2)
        ) {
          return i.toString();
        }
      }
    }
  }
  return null;
};
//uncomment this for one accoridon open at once
  // const [activeAccordionKey, setActiveAccordionKey] = useState(null);

  return <Fragment>
    {renderMenu()}

    <Toaster
        show={showToast}
        message={toastMessage}
        variant={toastVariant}
        onClose={() => setShowToast(false)}
    />
    </Fragment>;
}



export default Sidebar;

